import { TextNode } from 'lexical';
import { $createProjectMetadataTokenNode } from '../../nodes/ProjectMetadataTokenNode';

export const TOKEN_REGEX = /\{\{([^}]+)\}\}/;

export const $textNodeTransform = (metadata: Record<string, string>) => (node: TextNode): void => {
  if (!node.isSimpleText()) {
    return;
  }

  const text = node.getTextContent();

  if (!TOKEN_REGEX.test(text)) {
    return;
  }

  const match = TOKEN_REGEX.exec(text);

  if (match) {
    const fullMatch = match[0];
    const tokenKey = match[1];

    if (!tokenKey) {
      return;
    }

    const startIndex = text.indexOf(fullMatch);
    const endIndex = startIndex + fullMatch.length;

    const metadataTokenNode = $createProjectMetadataTokenNode(tokenKey, metadata);
    if (metadataTokenNode) {
      let targetNode: TextNode;

      if (startIndex === 0) {
        [targetNode] = node.splitText(endIndex);
      } else {
        [, targetNode] = node.splitText(startIndex, endIndex);
      }

      metadataTokenNode.setStyle(targetNode.getStyle());
      targetNode.replace(metadataTokenNode);
    }
  }
};
